<template>
  <div class="shopcart">
    <div class="main">
      <div class="main-carts">
        <div class="cart-item" v-for="(item, idx) in cartList" v-bind:key="idx">
          <div class="cart-left"></div>
          <div class="cart-right">
            <van-card
              :price="item.price"
              :desc="item.remarks"
              :title="item.name"
              :thumb="item.coverImg"
            >
              <template #num>
                <div style="float: left">
                  <van-stepper v-model="item.num" integer :disabled="true" />
                </div>
              </template>
            </van-card>
          </div>
        </div>
      </div>
      <div class="cardPay">
        <div class="cards">
          <van-cell-group title="储值卡支付">
            <van-checkbox-group v-model="checkedCards">
              <van-cell-group>
                <van-cell
                  v-for="(item, index) in cardList"
                  clickable
                  :key="item.prepaidCardCode"
                  :title="'卡号: ' + item.prepaidCardCode"
                  :label="'余额: ' + item.surplusMoney"
                  :value="item.categoryName + ''"
                  title-class="cardTitle"
                  value-class="cardValue"
                  label-class="cardLabel"
                  @click="toggle(index)"
                >
                  <template #right-icon>
                    <van-checkbox
                      :name="item.prepaidCardCode"
                      v-model="item.checked"
                      ref="checkboxes"
                    />
                  </template>
                </van-cell>
              </van-cell-group>
            </van-checkbox-group>
          </van-cell-group>
        </div>
        <div v-if="showOrderPayType">
          <van-cell-group title="其它支付方式">
            <!-- <van-radio-group v-model="defaultPay"> -->
            <van-cell-group>
              <van-cell>
                <van-cell
                  clickable
                  title="微信/支付宝"
                  title-class="cardTitle"
                  value-class="cardValue"
                  label-class="cardLabel"
                >
                  <template #right-icon>
                    <van-checkbox @click="payChange" v-model="defaultPay" />
                  </template>
                </van-cell>
              </van-cell>
            </van-cell-group>
          </van-cell-group>
        </div>
      </div>
      <!-- </van-checkbox> -->
    </div>
    <van-goods-action>
      <div class="totalAmt">总计：{{ totalAmt }}元</div>

      <van-goods-action-button
        style="width: 10px"
        type="danger"
        text="支付订单"
        @click="dopay"
      />
    </van-goods-action>
  </div>
</template>

<script>
import "../../assets/css/settle.less";
import { apiPost, queryGet } from "@/api/common";
import {} from "vant";
// const { checkboxGroup } = this.$refs;
export default {
  name: "Settle",
  data() {
    return {
      cartNum: "", //购物车数量
      totalAmt: "", //结算总额
      shopInfo: {}, //店铺信息
      cardInfo: {}, //存储客户信息的储值卡
      cartList: [], //待结算列表
      checkedCards: [], //选中的待支付储值卡
      cardList: [], //储值卡列表
      showOrderPayType: false, //是否显示其它付款方式
      weixinOrAliapy: 1,
      defaultPay: true,
      cardReadOnly: false, //是否可以切换选卡
    };
  },
  components: {},
  created() {
    this.loadComments();
    this.getCartList();
  },
  computed: {},

  methods: {
    loadComments() {
      // debugger;
      let s = sessionStorage.getItem("shopInfo");
      let c = sessionStorage.getItem("cardInfo");
      this.shopInfo = s ? JSON.parse(s) : "";
      this.cardInfo = c ? JSON.parse(c) : "";

      this.totalAmt = parseFloat(sessionStorage.getItem("totalAmt"));
    },
    fix2(val) {
      return Number(val).toFixed(2);
    },
    loadCard() {
      let _this = this;
      let phone = this.cardInfo.tel;
      let params = {
        phone: phone,
        shopCode: this.shopInfo.shopCode,
      };
      let url = "/api/mbrinfo/getStoredValueCard";
      queryGet(url, params)
        .then((resp) => {
          let _data = resp.data;
          if (_data.code == "0000") {
            let _result = _data.data;
            let rePayAmt = _this.totalAmt; //待支付金额
            _this.cardList = _result.results.valueCardQueryVo.valueCardVosl;
            for (let i = 0; i < _this.cardList.length; i++) {
              let item = _this.cardList[i];
              if (rePayAmt > 0) {
                _this.checkedCards.push(_this.cardList[i].prepaidCardCode);
              }
              rePayAmt = rePayAmt - item.surplusMoney;
            }
            if (rePayAmt > 0) {
              _this.showOrderPayType = true;
              _this.cardReadOnly = true;
            }
            sessionStorage.setItem(
              "otherPayType",
              _this.showOrderPayType ? 4 : 3
            );
            sessionStorage.setItem("rePayAmt", rePayAmt);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getCartList() {
      let _this = this;
      let url = "/api/order/selectShoppingCart";
      let data = {
        code: this.shopInfo.shopCode,
        mobile: this.cardInfo.tel,
      };
      apiPost(url, data).then((resp) => {
        let _data = resp.data;
        let _code = _data.code;
        if (_code == "0000") {
          this.cartNum = _data.data.results.totalNum;
          let carts = _data.data.results.orderItemList;
          if (carts == null || carts.length == 0) {
            _this.$toast.fail("购物车里没有商品,请添加商品");
            this.$router.push({ path: "buy" });
          }
          _this.cartList = [];
          _this.totalAmt = 0;
          for (let i = 0; i < carts.length; i++) {
            let item = carts[i];
            if (item.isCheck == 0) {
              _this.cartList.push(item);
              _this.totalAmt += item.payMoney;
            }
          }
          this.loadCard();
        } else {
          _this.$toast.fail(_data.msg);
        }
      });
    },
    dopay() {
      // this.$refs.checkboxes;
      let payCards = []; //用于保存已选择待支付的储值卡列表
      let cardTotalAmt = 0; //保存所选卡的总额,用天判断是否可足额支付
      let cardTotalAll = 0;
      for (let i = 0; i < this.$refs.checkboxes.length; i++) {
        let checked = this.$refs.checkboxes[i].checked;
        let item = this.cardList[i];
        cardTotalAll += item.surplusMoney;
        if (checked) {
          //计算所选储值卡的总额,并保存所选卡
          cardTotalAmt += item.surplusMoney;
          payCards.push(item);
        }
      }
      if (cardTotalAmt < this.totalAmt) {
        if (cardTotalAmt < cardTotalAll) {
          this.$toast.fail("储值卡余额不足,请重新选择!");
          return;
        }
        // this.$toast.fail("所选储值卡总余额不足于支付订单!");
        // return;
        sessionStorage.setItem("rePayAmt", this.totalAmt - cardTotalAmt);
      }
      sessionStorage.setItem("payCards", JSON.stringify(payCards));
      sessionStorage.setItem("totalAmt", this.totalAmt);
      sessionStorage.setItem("weixinOrAliapy", this.weixinOrAliapy);
      this.$router.push({ path: "cardPay" });
    },

    toggle(index) {
      if (this.cardReadOnly) {
        this.$refs.checkboxes[index].toggle(true);
      } else {
        this.$refs.checkboxes[index].toggle();
      }
    },
    payChange() {
      this.defaultPay = true;
    },
  },
};
</script>


